import Vue from 'vue';
import Router from 'vue-router';

import MainPage from '@/views/MainPage.vue';
import HomePage from '#/views/HomePage/HomePage.vue';
import PostsView from '@/views/PostsView.vue';
import PostView from '@/views/PostView.vue';
import PageView from '@/views/PageView.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior() {
		return new Promise((resolve) => {
			setTimeout(() => {
				try {
					document.getElementsByClassName('content-container')[0].scrollTo(0, 0);
				} finally {
					resolve({ x: 0, y: 0 });
				}
			}, 500);
		});
	},
	routes: [
		{
			name: 'root',
			path: '/',
			redirect: '/home',
			components: {
				// main page holds the sidebar and the home page
				default: MainPage,
			},
			// children of the main page component
			children: [
				{
					name: 'Home',
					path: 'home',
					components: {
						default: HomePage,
					},
				},
				// route for displaying all posts from a category
				{
					name: 'Posts',
					path: 'posts/:id/',
					props: {
						default: true,
					},
					components: {
						default: PostsView,
					},
				},
				// route for displaying a single post
				{
					name: 'Post',
					path: 'posts/post/:id',
					props: {
						default: true,
					},
					components: {
						default: PostView,
					},
				},
				// route for displaying a single page
				{
					name: 'Page',
					path: 'page/:id',
					props: {
						default: true,
					},
					components: {
						default: PageView,
					},
				},
			],
		},
	],
});
